import { auth } from "./config";

/**
 * JSON request headers for Cloud Function calls, plus the signed-in user's
 * Firebase ID token. The backend takes the uid from this token only.
 */
export async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  const idToken = await auth.currentUser?.getIdToken();
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  return headers;
}
